import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { NonRxProductAddToCartButton } from '../NonRxProductAddToCartButton/NonRxProductAddToCartButton.js';

const NonRxProductCTA = ({ action , addToCartConfig , storesRoute , handleConversionEvent ,  })=>{
    const { getLabel  } = useIntl();
    if (action === 'ADD_TO_CART') {
        // Add to Cart button
        return /*#__PURE__*/ React.createElement(NonRxProductAddToCartButton, swcHelpers.extends({}, addToCartConfig));
    }
    // Find a Store button
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: handleConversionEvent,
        caption: getLabel('products.actions.excludedFromCheckout'),
        "data-t": "btn-excluded-from-checkout",
        href: storesRoute
    });
};

export { NonRxProductCTA };
//# sourceMappingURL=NonRxProductCTA.js.map
